var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getSignupBanner)?_c('section',{staticClass:"registration-banner"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("\n    Cadastre-se agora e tenha\n    "),_c('br'),_vm._v("\n    acesso gratuito a fretes mais competitivos!\n  ")])
}]

export { render, staticRenderFns }